import { errorHandler } from "./errorHandler";
import { UserData } from "../interface";
import { apiRequest } from "./apiRequest";

export const enableUsers = async (
  id: number,
  args: Partial<UserData>
): Promise<string> => {
  try {
    const data = await apiRequest<{ message: string }>(
      "patch",
      `/users/status/${id}`,
      { data: args }
    );
    return data.message;
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed");
  }
};
